import { ActionType, createAction } from 'typesafe-actions';

export const reportProblem = createAction('REPORT_PROBLEM')<void>();

export type ReportActions = ActionType<typeof reportProblem>;
